import React from 'react'

import { actionsColumn, conditionNameColumn, providersColumn, sitesColumn } from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import AlertsBaseTable from "Pages/ReportsAlerts/Alerts/@components/Table"
import { priceChangeComparisonColumn } from "Pages/ReportsAlerts/Alerts/Conditions/PriceChange/Table/columns"


export default function PriceChangeTable({ data, isLoading, onDeleteAlert, onEditAlert, filterConditions }) {

	return <AlertsBaseTable
		title="Alerts: Price Change"
		data={data}
		isLoading={isLoading}
		filterConditions={filterConditions}
		columns={[
			conditionNameColumn(),
			...sitesColumn(),
			providersColumn(),
			priceChangeComparisonColumn(),
			actionsColumn(onDeleteAlert, onEditAlert)
		]}
		legend={[
			{ icon: "percent", value: "%", label: "Percentage" },
			{ icon: "money-bills", value: "$", label: "Currency", iconProps: { color: "success.dark" } },
			{
				icon: "arrow-up",
				value: "Price increase",
				label: "Price increase",
				iconProps: { color: "success.main" }
			},
			{
				icon: "arrow-down",
				value: "Price decrease",
				label: "Price Decrease",
				iconProps: { color: "error.main" }
			},
			{
				icon: "arrow-down-arrow-up",
				value: "Price increase/decrease",
				label: "Price Difference",
				iconProps: { color: "warning.main" }
			},
		]}
	/>
}